import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { ApplicationProvider } from './context/ApplicationContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import MDAsPage from './pages/MDAsPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailsPage from './pages/ServiceDetailsPage';
import PaymentPage from './pages/PaymentPage';
import ConfirmationPage from './pages/ConfirmationPage';
import UserProfilePage from './pages/UserProfilePage';
import PaymentHistory from './pages/PaymentHistory';
import TrackApplication from './pages/TrackApplication';
import MyApplicationsPage from './pages/MyApplicationsPage';
import NotificationsPage from './pages/NotificationsPage';
import SupportPage from './pages/SupportPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import HelpPage from './pages/HelpPage';
import ProtectedRoute from './components/ProtectedRoute';
// Admin pages
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import UserManagement from './pages/admin/UserManagement';
import ApplicationManagement from './pages/admin/ApplicationManagement';
import MDAManagement from './pages/admin/MDAManagement';
import ServiceManagement from './pages/admin/ServiceManagement';
import PaymentManagement from './pages/admin/PaymentManagement';
import ReportsAnalytics from './pages/admin/ReportsAnalytics';
import Notifications from './pages/admin/Notifications';
import Support from './pages/admin/Support';
import Settings from './pages/admin/Settings';
import AdminProfile from './pages/admin/AdminProfile';
import Help from './pages/admin/Help';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import './index.css';
// Import the EsosaProvider
import { EsosaProvider } from './components/AIAssistant/EsosaContext';
// Import new context providers
import { NotificationProvider } from './context/NotificationContext';
import { WorkflowProvider } from './context/WorkflowContext';
// Import the new ApplicationAttacherPage
import ApplicationAttacherPage from './pages/ApplicationAttacherPage';
export function App() {
  return <AuthProvider data-id="element-0">
      <AdminAuthProvider data-id="element-1">
        <NotificationProvider data-id="element-2">
          <ApplicationProvider data-id="element-3">
            <WorkflowProvider data-id="element-4">
              <Router data-id="element-5">
                <EsosaProvider data-id="element-6">
                  <Routes data-id="element-7">
                    {/* Public Routes */}
                    <Route path="/" element={<LandingPage data-id="element-9" />} data-id="element-8" />
                    <Route path="/login" element={<LoginPage data-id="element-11" />} data-id="element-10" />
                    <Route path="/register" element={<RegisterPage data-id="element-13" />} data-id="element-12" />
                    <Route path="/terms" element={<TermsPage data-id="element-15" />} data-id="element-14" />
                    <Route path="/privacy" element={<PrivacyPage data-id="element-17" />} data-id="element-16" />
                    <Route path="/help" element={<HelpPage data-id="element-19" />} data-id="element-18" />
                    {/* Protected User Routes */}
                    <Route path="/dashboard" element={<ProtectedRoute data-id="element-21">
                          <Dashboard data-id="element-22" />
                        </ProtectedRoute>} data-id="element-20" />
                    <Route path="/mdas" element={<ProtectedRoute data-id="element-24">
                          <MDAsPage data-id="element-25" />
                        </ProtectedRoute>} data-id="element-23" />
                    <Route path="/mdas/:mdaId/services" element={<ProtectedRoute data-id="element-27">
                          <ServicesPage data-id="element-28" />
                        </ProtectedRoute>} data-id="element-26" />
                    <Route path="/services/:serviceId" element={<ProtectedRoute data-id="element-30">
                          <ServiceDetailsPage data-id="element-31" />
                        </ProtectedRoute>} data-id="element-29" />
                    <Route path="/payment/:serviceId" element={<ProtectedRoute data-id="element-33">
                          <PaymentPage data-id="element-34" />
                        </ProtectedRoute>} data-id="element-32" />
                    <Route path="/confirmation/:transactionId" element={<ProtectedRoute data-id="element-36">
                          <ConfirmationPage data-id="element-37" />
                        </ProtectedRoute>} data-id="element-35" />
                    <Route path="/profile" element={<ProtectedRoute data-id="element-39">
                          <UserProfilePage data-id="element-40" />
                        </ProtectedRoute>} data-id="element-38" />
                    <Route path="/payment-history" element={<ProtectedRoute data-id="element-42">
                          <PaymentHistory data-id="element-43" />
                        </ProtectedRoute>} data-id="element-41" />
                    <Route path="/track-application" element={<ProtectedRoute data-id="element-45">
                          <TrackApplication data-id="element-46" />
                        </ProtectedRoute>} data-id="element-44" />
                    <Route path="/track-application/:referenceNumber" element={<ProtectedRoute data-id="element-48">
                          <TrackApplication data-id="element-49" />
                        </ProtectedRoute>} data-id="element-47" />
                    <Route path="/my-applications" element={<ProtectedRoute data-id="element-51">
                          <MyApplicationsPage data-id="element-52" />
                        </ProtectedRoute>} data-id="element-50" />
                    <Route path="/notifications" element={<ProtectedRoute data-id="element-54">
                          <NotificationsPage data-id="element-55" />
                        </ProtectedRoute>} data-id="element-53" />
                    <Route path="/support" element={<ProtectedRoute data-id="element-57">
                          <SupportPage data-id="element-58" />
                        </ProtectedRoute>} data-id="element-56" />
                    {/* Utility Route */}
                    <Route path="/attach-application" element={<ProtectedRoute data-id="element-60">
                          <ApplicationAttacherPage data-id="element-61" />
                        </ProtectedRoute>} data-id="element-59" />
                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<AdminLogin data-id="element-63" />} data-id="element-62" />
                    <Route path="/admin/dashboard" element={<ProtectedAdminRoute data-id="element-65">
                          <AdminDashboard data-id="element-66" />
                        </ProtectedAdminRoute>} data-id="element-64" />
                    <Route path="/admin/users" element={<ProtectedAdminRoute requiredPermission="users:read" data-id="element-68">
                          <UserManagement data-id="element-69" />
                        </ProtectedAdminRoute>} data-id="element-67" />
                    <Route path="/admin/applications" element={<ProtectedAdminRoute requiredPermission="applications:read" data-id="element-71">
                          <ApplicationManagement data-id="element-72" />
                        </ProtectedAdminRoute>} data-id="element-70" />
                    <Route path="/admin/mdas" element={<ProtectedAdminRoute requiredPermission="mdas:read" data-id="element-74">
                          <MDAManagement data-id="element-75" />
                        </ProtectedAdminRoute>} data-id="element-73" />
                    <Route path="/admin/services" element={<ProtectedAdminRoute requiredPermission="services:read" data-id="element-77">
                          <ServiceManagement data-id="element-78" />
                        </ProtectedAdminRoute>} data-id="element-76" />
                    <Route path="/admin/payments" element={<ProtectedAdminRoute requiredPermission="payments:read" data-id="element-80">
                          <PaymentManagement data-id="element-81" />
                        </ProtectedAdminRoute>} data-id="element-79" />
                    <Route path="/admin/reports" element={<ProtectedAdminRoute requiredPermission="reports:read" data-id="element-83">
                          <ReportsAnalytics data-id="element-84" />
                        </ProtectedAdminRoute>} data-id="element-82" />
                    <Route path="/admin/settings" element={<ProtectedAdminRoute requiredPermission="settings:read" data-id="element-86">
                          <Settings data-id="element-87" />
                        </ProtectedAdminRoute>} data-id="element-85" />
                    <Route path="/admin/profile" element={<ProtectedAdminRoute data-id="element-89">
                          <AdminProfile data-id="element-90" />
                        </ProtectedAdminRoute>} data-id="element-88" />
                    <Route path="/admin/notifications" element={<ProtectedAdminRoute data-id="element-92">
                          <Notifications data-id="element-93" />
                        </ProtectedAdminRoute>} data-id="element-91" />
                    <Route path="/admin/support" element={<ProtectedAdminRoute data-id="element-95">
                          <Support data-id="element-96" />
                        </ProtectedAdminRoute>} data-id="element-94" />
                    <Route path="/admin/help" element={<ProtectedAdminRoute data-id="element-98">
                          <Help data-id="element-99" />
                        </ProtectedAdminRoute>} data-id="element-97" />
                    {/* Fallback route */}
                    <Route path="*" element={<Navigate to="/" replace data-id="element-101" />} data-id="element-100" />
                  </Routes>
                </EsosaProvider>
              </Router>
            </WorkflowProvider>
          </ApplicationProvider>
        </NotificationProvider>
      </AdminAuthProvider>
    </AuthProvider>;
}